export default __webpack_public_path__ + "static/og-image-b2635436b2ea6a490652a44e96b00ede.png";